import React, { useState, useRef, useEffect } from "react";

export function InfoTooltip({ children }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close tooltip if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref]);

  return (
    <div style={{ display: "inline-block", position: "relative" }} ref={ref}>
      <i
        onClick={() => setOpen((prev) => !prev)}
        className="fa-solid fa-circle-info ms-2 text-muted"
        role="button"
        tabIndex={0}
      />
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 999,
            background: "white",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            minWidth: "200px",
            maxWidth: "250px",
            whiteSpace: "normal",
            wordWrap: "break-word"
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
